import React from 'react';

const Gym = props => (
  <svg width={22} height={22} fill="none" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m12.46 7.583-4.962 4.963M14.318 9.45l-4.963 4.955M1.922 14.405a1.315 1.315 0 0 1 1.859-1.86l5.576 5.577c.517.517.517 1.35 0 1.859a1.315 1.315 0 0 1-1.859 0l-5.585-5.576h.009Z"
      stroke="#224251"
      strokeLinejoin="round"
    />
    <path
      d="M2.536 11.31a1.307 1.307 0 0 1 0-1.86 1.307 1.307 0 0 1 1.86 0l8.056 8.058c.518.518.518 1.35 0 1.859a1.315 1.315 0 0 1-1.858 0L2.536 11.31ZM9.357 4.488a1.315 1.315 0 0 1 1.86-1.858l8.056 8.057c.518.517.518 1.35 0 1.859a1.307 1.307 0 0 1-1.858 0L9.357 4.488ZM1.3 17.508a1.307 1.307 0 0 1 0-1.858 1.307 1.307 0 0 1 1.859 0l3.104 3.103c.508.518.508 1.35 0 1.859a1.307 1.307 0 0 1-1.86 0L1.3 17.508ZM12.462 3.866a1.307 1.307 0 0 1 0-1.859 1.307 1.307 0 0 1 1.859 0l5.576 5.576c.517.518.517 1.35 0 1.86a1.307 1.307 0 0 1-1.859 0l-5.576-5.586v.009Z"
      stroke="#224251"
      strokeLinejoin="round"
    />
    <path
      d="M15.556 3.243a1.307 1.307 0 0 1 0-1.858 1.315 1.315 0 0 1 1.859 0l3.103 3.103c.509.509.509 1.35 0 1.86a1.323 1.323 0 0 1-1.858 0l-3.095-3.105h-.01Z"
      stroke="#224251"
      strokeLinejoin="round"
    />
  </svg>
);

export default Gym;
